import ReactGA, { EventArgs, GaOptions } from 'react-ga';

import { keys } from 'app/config/keys';
import { AnalyticsEventKey } from 'app/services/analytics/events';

import events from './events';
import gaConfig from './ga.config';

// Local Variables
function shouldDebugGA() {
  if (window) {
    return keys.DEBUG_GA;
  }
}

// Exports
export function gaInit() {
  if (keys.NODE_ENV !== 'test') {
    ReactGA.initialize(gaConfig.GOOGLE_ANALYTICS_KEY,
      {
        debug: keys.__DEV__ && shouldDebugGA(),
        testMode: keys.__DEV__,
      });
  }
}

export function gaSet(values: GaOptions) {
  if (keys.NODE_ENV !== 'test') {
    ReactGA.set(values);
  }
}

export function gaTrackPage(pathname: string, search: string) {
  ReactGA.pageview(pathname + search);
}

export function gaTrackEvent(eventKey: AnalyticsEventKey, gaEventArgOverrides?: Partial<EventArgs>) {
  if (keys.NODE_ENV !== 'test') {
    ReactGA.event(events[eventKey](gaEventArgOverrides));
  }
}
